/**
 * Sort order options for snippet lists.
 *
 * Used by the SnippetSortDropdown and useSnippetFilterAndSort to determine
 * how snippets are ordered in the panel.
 */
export enum SnippetSortOrder {
	CREATED_AT = 'CREATED_AT',
	LAST_UPDATED = 'LAST_UPDATED',
	POPULARITY = 'POPULARITY',
	ALPHABETICAL = 'ALPHABETICAL',
}

export const DEFAULT_SNIPPET_SORT_ORDER = SnippetSortOrder.CREATED_AT;
